import { render } from "./OptionInfo.vue?vue&type=template&id=bb895c6a&scoped=true"
import script from "./OptionInfo.vue?vue&type=script&lang=js"
export * from "./OptionInfo.vue?vue&type=script&lang=js"

import "./OptionInfo.vue?vue&type=style&index=0&id=bb895c6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb895c6a"]])

export default __exports__